import { useMemo, useState } from 'react';
import { TransactionResultStatus } from 'components';
import { BalanceAddress } from 'types';

export const useTokenTab = () => {
  const [isLoading, setLoading] = useState(false);
  const [searchAddressResult, setSearchAddressResult] = useState<BalanceAddress | undefined>();
  const [selectedTokenIndex, setSelectedTokenIndex] = useState<any>(null);
  const [instantSendDialogShown, setInstantSendDialogShown] = useState(false);
  const [transactionMessagePopupShown, setTransactionMessagePopupShown] = useState(false);
  const [transactionResultStatus, setTransactionResultStatus] = useState<TransactionResultStatus>();
  const [transactionResultMessage, setTransactionResultMessage] = useState('');

  return useMemo(
    () => ({
      isLoading,
      setLoading,
      searchAddressResult,
      setSearchAddressResult,
      selectedTokenIndex,
      setSelectedTokenIndex,
      instantSendDialogShown,
      setInstantSendDialogShown,
      transactionMessagePopupShown,
      setTransactionMessagePopupShown,
      transactionResultStatus,
      setTransactionResultStatus,
      transactionResultMessage,
      setTransactionResultMessage,
    }),
    [
      isLoading,
      searchAddressResult,
      selectedTokenIndex,
      instantSendDialogShown,
      transactionMessagePopupShown,
      transactionResultStatus,
      transactionResultMessage,
    ]
  );
};
